module.exports = __webpack_public_path__ + "img/60379c094b5d8b4db3976a2d21668c67.png";